import React from 'react';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';

function renderInput(inputProps) {
    const { InputProps, label, placeholder, classes, ref, ...other } = inputProps;

    return (
        <TextField
            InputProps={{
                inputRef: ref,
                classes: {
                    root: classes.inputRoot,
                },
                ...InputProps,
            }}
            style={{ marginBottom: 15 }}
            label={label}
            // placeholder={placeholder}
            {...other}
        />
    );
}




class FiltroDownshiftMultiple extends React.Component {
    constructor(props) {
        super(props);
        this.state = { texto: "" }
        this.getSuggestions = this.getSuggestions.bind(this)
    }
    componentDidMount() {
        if (this.props.customFormInterno)
            this.props.listar(this.props.customFormInterno);
    }

    handleKeyDown = (event, isOpen) => {
        const { texto } = this.state;
        const { input: { value, onChange } } = this.props;
        let array = value ? value.slice() : [];
        if (array.length && !texto.length && keycode(event) === 'backspace') {
            onChange(array.slice(0, array.length - 1))
        }
        if (keycode(event) === "enter") {
            let suges = this.getSuggestions(texto)
            if (!isOpen || !suges.length) {
                this.handleChange(texto)
            }
        }
    };

    handleInputChange = event => {
        this.setState({ texto: event.target.value });
    };

    handleChange = item => {
        const { input: { value, onChange } } = this.props;
        let array = value ? value.slice() : [];

        if (array.indexOf(item) === -1) {
            array.push(item);
        }
        onChange(array)
        this.setState({ texto: "" });
    };

    handleDelete = item => () => {
        const { input: { value, onChange } } = this.props;
        let array = value ? value.slice() : [];
        array.splice(array.indexOf(item), 1);
        onChange(array)
    };

    getSuggestions(inputValue) {
        const { input: { value, onChange } } = this.props;
        let array = value ? value.slice() : [];

        let count = 0;
        let suggestions
        if (this.props.possiveis) {
            suggestions = this.props.possiveis.slice()
        }

        array.forEach(element => {
            if (!suggestions.includes(element)) {
                suggestions.push(element)
            }
        });

        return suggestions.filter(suggestion => {
            const keep =
                (!inputValue || suggestion.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1) &&
                count < 5;

            if (keep) {
                count += 1;
            }

            return keep;
        });
    }

    renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
        const isHighlighted = highlightedIndex === index;
        const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

        return (
            <MenuItem
                {...itemProps}
                key={suggestion}
                selected={isHighlighted}
                component="div"
                style={{
                    fontWeight: isSelected ? 500 : 400,
                }}
            >
                {suggestion}
            </MenuItem>
        );
    }

    render() {
        const { classes, label, placeholder } = this.props;
        const { texto } = this.state;
        const { input: { value, onChange } } = this.props;

        let array = value || [];
        return (
            <Downshift inputValue={texto} onChange={this.handleChange} selectedItem={array}>
                {({
                    getInputProps,
                    getItemProps,
                    isOpen,
                    inputValue: texto,
                    selectedItem: array,
                    highlightedIndex,
                }) => (
                        <div className={classes.container}>
                            {renderInput({
                                fullWidth: true,
                                classes,
                                label,
                                placeholder,
                                InputProps: getInputProps({
                                    startAdornment: array.map(item => (
                                        <Chip
                                            key={item}
                                            tabIndex={-1}
                                            label={item}
                                            className={classes.chip}
                                            onDelete={this.handleDelete(item)}
                                        />
                                    )),
                                    onChange: this.handleInputChange,
                                    onKeyDown: (event) => this.handleKeyDown(event, isOpen),
                                    placeholder,
                                    id: 'integration-downshift-multiple',
                                }),
                            })}
                            {isOpen ? (
                                <Paper className={classes.paper} square>
                                    {this.getSuggestions(texto).map((suggestion, index) =>
                                        this.renderSuggestion({
                                            suggestion,
                                            index,
                                            itemProps: getItemProps({ item: suggestion }),
                                            highlightedIndex,
                                            selectedItem: array,
                                        }),
                                    )}
                                </Paper>
                            ) : null}
                        </div>
                    )}
            </Downshift>
        );
    }
}

FiltroDownshiftMultiple.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        height: 250,
    },
    container: {
        flexGrow: 1,
        position: 'relative',
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    chip: {
        margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
    },
    inputRoot: {
        flexWrap: 'wrap',
    },
});


FiltroDownshiftMultiple = withStyles(styles)(FiltroDownshiftMultiple);

export default FiltroDownshiftMultiple;



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Tags/components/Tags/Tags.js